import { useMutation } from '@tanstack/react-query';
import {
  CareSoftSmsService,
  UnlockSmsRateLimitDto,
  UnlockSmsRateLimitEntity,
} from 'services/openapi';

export const useUnlockSmsRateLimitMutation = () => {
  const { isLoading, error, data, isError, isSuccess, mutate, mutateAsync } =
    useMutation<UnlockSmsRateLimitEntity, Error, UnlockSmsRateLimitDto>({
      mutationFn: (variables: UnlockSmsRateLimitDto) =>
        CareSoftSmsService.careSoftSmsControllerUnlockRateLimit(variables),
    });

  return {
    isLoading,
    isSuccess,
    error,
    data,
    isError,
    mutate,
    mutateAsync,
  };
};
